import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgScreenshot = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "100%",
	height: "100%",
	viewBox: "0 0 23 22",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	xmlSpace: "preserve",
	"xmlns:serif": "http://www.serif.com/",
	style: {
		fillRule: "evenodd",
		clipRule: "evenodd"
	},
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		id: "Laag-1",
		"serif:id": "Laag 1"
	}), /* @__PURE__ */ _jsxs("g", {
		id: "Laag-11",
		"serif:id": "Laag 1",
		transform: "matrix(0.956305,0,0,0.906672,0.186389,0.324632)",
		children: [
			/* @__PURE__ */ _jsx("g", {
				transform: "matrix(0.557641,0,0,0.573697,-3.683591,-0.439645)",
				children: /* @__PURE__ */ _jsx("circle", {
					cx: 27.7,
					cy: 24.3,
					r: 2.7,
					style: {
						fill: "none",
						stroke: "currentColor",
						strokeWidth: "2.99px"
					}
				})
			}),
			/* @__PURE__ */ _jsx("g", {
				transform: "matrix(0.551277,0,0,0.573697,-3.507304,-0.439645)",
				children: /* @__PURE__ */ _jsx("circle", {
					cx: 27.7,
					cy: 24.3,
					r: 9.8,
					style: {
						fill: "none",
						stroke: "currentColor",
						strokeWidth: "2.99px"
					}
				})
			}),
			/* @__PURE__ */ _jsx("g", {
				transform: "matrix(0.506057,0,0,0.573697,-2.280031,-0.439645)",
				children: /* @__PURE__ */ _jsx("path", {
					d: "M6.3,13.9L6.3,35.1C6.3,36.8 7.7,38.2 9.4,38.2L46.1,38.2C47.8,38.2 49.2,36.8 49.2,35.1L49.2,13.9C49.2,12.2 47.8,10.8 46.1,10.8L38.4,10.8C37.6,10.8 36.9,10.5 36.4,10L32.9,7C32.3,6.5 31.6,6.2 30.9,6.2L24.7,6.2C23.9,6.2 23.2,6.5 22.6,7L19.4,9.9C18.8,10.4 18.1,10.7 17.3,10.7L9.5,10.7C7.8,10.7 6.4,12.1 6.4,13.8L6.3,13.9Z",
					style: {
						fill: "none",
						fillRule: "nonzero",
						stroke: "currentColor",
						strokeWidth: "2.99px"
					}
				})
			})
		]
	})]
});
export default SvgScreenshot;
